import React, { useState } from 'react';

// Sortable table columns for the V2 report pages. A page keeps its own order until a column heading is chosen; choosing a heading sorts by it
// (numbers as numbers, text with its digits in order, empty last), choosing it again reverses it, and a third time goes back to the page's order.

const isEmpty = (v) => v === null || v === undefined || v === '';

const compare = (a, b) => {
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
};

// rows sorted by the value that column.get(row) gives, or as they are when no column is chosen. Empty values are last in either direction.
export const sortRows = (rows, column, dir) => {
  if (!column) return rows;
  const sign = dir === 'desc' ? -1 : 1;
  return [...rows].sort((x, y) => {
    const a = column.get(x);
    const b = column.get(y);
    if (isEmpty(a) || isEmpty(b)) return (isEmpty(a) ? 1 : 0) - (isEmpty(b) ? 1 : 0);
    return sign * compare(a, b);
  });
};

// { sort: {key, dir} | null, toggle(key), apply(rows, columns) } where columns is { key: { get(row) } }.
export const useSort = () => {
  const [sort, setSort] = useState(null);
  const toggle = (key) => setSort((s) => {
    if (!s || s.key !== key) return { key, dir: 'asc' };
    return s.dir === 'asc' ? { key, dir: 'desc' } : null;
  });
  const apply = (rows, columns) => (sort ? sortRows(rows, columns[sort.key], sort.dir) : rows);
  return { sort, toggle, apply };
};

// A column heading that sorts its table. `numeric` right-aligns it like the numbers under it.
export function SortHeader({ k, sort, onSort, numeric, children }) {
  const active = sort && sort.key === k;
  const dir = active ? sort.dir : null;
  return (
    <th className={numeric ? 'num' : undefined} aria-sort={dir === 'asc' ? 'ascending' : dir === 'desc' ? 'descending' : 'none'}>
      <button type="button" className="v2-sort" onClick={() => onSort(k)}>
        {children}
        <span className="v2-sort-mark" aria-hidden="true">{dir === 'asc' ? '▲' : dir === 'desc' ? '▼' : ''}</span>
      </button>
    </th>
  );
}
